module.exports = __webpack_public_path__ + "img/icon-virtual-visit.cd6b7f04.svg";